import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Paper, MenuList, MenuItem, ListItemIcon, ListItemText } from '@material-ui/core';
import { FileCopy as DuplicateIcon } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  contextMenu: {
    position: 'fixed',
    zIndex: 99999,
    minWidth: 150,
    '& .MuiMenuItem-root': {
      fontSize: '14px',
      minHeight: '36px',
    },
  },
}));

interface ContextMenuProps {
  x: number;
  y: number;
  onDuplicate: () => void;
  onClose: () => void;
}

const ContextMenu: React.FC<ContextMenuProps> = ({ x, y, onDuplicate, onClose }) => {
  const classes = useStyles();

  console.log("ContextMenu rendered at position:", x, y);

  const handleDuplicate = () => {
    console.log("Duplicate clicked");
    onDuplicate();
    onClose();
  };

  // Close context menu when clicking outside
  React.useEffect(() => {
    const handleClickOutside = () => {
      console.log("Click outside detected, closing context menu");
      onClose();
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [onClose]);

  return (
    <div 
      className={classes.contextMenu} 
      style={{ 
        left: x, 
        top: y,
        backgroundColor: 'white',
        border: '1px solid #ccc',
        borderRadius: '4px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        padding: '4px 0'
      }}
    >
      <div 
        style={{ 
          padding: '8px 16px', 
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}
        onClick={handleDuplicate}
        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
      >
        <DuplicateIcon fontSize="small" />
        Duplicate Field
      </div>
    </div>
  );
};

export default ContextMenu;
